import React from "react";

export default function Menu() {
  return (
    <div className="h-screen flex justify-center items-center bg-green-300">
      <h1 className="text-9xl uppercase font-black">Menu Page</h1>
    </div>
  );
}
